{
  "columnResizer": "Spaltenanpassung",
  "loading": "Laden...",
  "loadingMore": "Mehr laden ...",
  "resizeColumn": "Spaltengröße ändern",
  "sortAscending": "Aufsteigend sortieren",
  "sortDescending": "Absteigend sortieren"
}
